import {
  ObjectCondition,
  ObjectTrigger,
  SceneLightState,
} from '@/../client-generator/generated-clients/plants';
import EnumToRadioButton from '@/views/components/EnumToRadioButton/EnumToRadioButton.vue';
import { Options } from 'vue-class-component';
import SceneTriggerAndConditionGeneral from '../SceneTriggerAndConditionGeneral';

@Options({
  name: 'TriggerAndConditionLight',
  components: {
    EnumToRadioButton,
  },
})
export default class TriggerAndConditionLight extends SceneTriggerAndConditionGeneral {
  SceneLightState = SceneLightState;
  declare triggerOrActionToAdd: ObjectTrigger | ObjectCondition;

  get isConfirmEnabled() {
    return this.triggerOrActionToAdd.lightState != SceneLightState.None;
  }
}
